import * as React from 'react'
import { useModal } from '@components/modals/use-modal'
import { FeedingCard } from '@modules/reservations/improvements/kinds/feedings/feeding-card'

export const Feeding = (): JSX.Element => {
  const [showFeedingModal] = useModal('FeedingDetailsModal', { title: 'Szczegóły wyżywienia:' })

  return <FeedingCard onAction={showFeedingModal} />
}
